const holidayBudgetCalculator = {
	// Elements on page
	q1Radios: document.querySelectorAll('.question-one input[type="radio"'),
	q1ErrorMsg: document.querySelector('.question-one .field-validation-error'),
	ppPeopleErrorMsg: document.querySelector('.question-pp-people .field-validation-error'),
	ppDaysErrorMsg: document.querySelector('.question-pp-days .field-validation-error'),
	tbDaysErrorMsg: document.querySelector('.question-tb-days .field-validation-error'),
	page1PPFlow: document.getElementById('per-person-flow'),
	page1TotalFlow: document.getElementById('total-budget-flow'),
	screenOneForm: document.getElementById('budget'),
	screenTwoForm: document.getElementById('outgoings-before'),
	screenOne: document.querySelector('.holiday-budget-calculator__screen-1'),
	screenTwo: document.querySelector('.holiday-budget-calculator__screen-2'),
	screenThree: document.querySelector('.holiday-budget-calculator__screen-3'),
	screenTwoPPTitle: document.getElementById('pp-screen-two-heading').textContent,
	screenTwoTBTitle: document.getElementById('tb-screen-two-heading').textContent,
	screenTwoTitle: document.getElementById('screen-two-title'),
	screenThreePPTitle: document.getElementById('pp-screen-three-heading').textContent,
	screenThreeTBTitle: document.getElementById('tb-screen-three-heading').textContent,
	resultsLeftOverEachDay: document.querySelector('.results--left-over--each-day--container'),
	ppCostEachDay: document.getElementById('pp-cost-each-day'),
	tbCostEachDay: document.getElementById('tb-cost-each-day'),
	screenThreeTitle: document.getElementById('screen-three-title'),
	s2BackButtonText: document.getElementById('back-button-text--screen-two')
		? document.getElementById('back-button-text--screen-two').textContent
		: 'Edit your budget',
	s3BackButtonText: document.getElementById('back-button-text--screen-three')
		? document.getElementById('back-button-text--screen-three').textContent
		: 'Edit outgoings before your trip',
	progressTitleOne: document.getElementById('holiday-budget-calculator__progress-title-1'),
	progressTitleTwo: document.getElementById('holiday-budget-calculator__progress-title-2'),
	progressTitleThree: document.getElementById('holiday-budget-calculator__progress-title-3'),
	progressIndicator: document.querySelector('.holiday-budget-calculator__progress--indicator'),
	progressCounter: document.querySelector('.holiday-budget-calculator__progress--count'),
	backButton: document.querySelector('.edit-previous'),
	backButtonText: document.querySelector('.edit-previous .arrow-link__title'),
	addSpendButton: document.getElementById('add-another-spend'),
	addSpendMarkup: document.querySelector('.add-category'),
	downloadPdfButton: document.getElementById('download-pdf'),

	// Per Person flow
	ppBudgetField: document.getElementById('pp-budget'),
	ppPeopleField: document.getElementById('pp-people'),
	ppDaysField: document.getElementById('pp-days'),

	// Total budget flow
	tbBudgetField: document.getElementById('tb-budget'),
	tbDaysField: document.getElementById('tb-days'),

	// Outgoings fields
	travelCostsField: document.getElementById('outgoings-travel-costs'),
	accommodationCostsField: document.getElementById('outgoings-accommodation-costs'),
	travelInsuranceCostsField: document.getElementById('outgoings-travel-insurance-costs'),
	petCareCostsField: document.getElementById('outgoings-pet-costs'),
	foodAndDrinkCostsField: document.getElementById('outgoings-food-and-drink-costs'),
	mealsOutCostsField: document.getElementById('outgoings-meals-out-costs'),
	activitiesCostsField: document.getElementById('outgoings-activities-costs'),
	giftsCostsField: document.getElementById('outgoings-gifts-costs'),
	screenThreeFields: document.querySelectorAll('.holiday-budget-calculator__screen-3 input[type="text"]'),

	// Results
	resultsDaysFields: document.querySelectorAll('.results--days'),
	resultsBudgetField: document.querySelector('.results--budget'),
	resultsTotalSpendFieldPPOnly: document.querySelector('.results--total-spend__pp-only'),
	resultsTotalSpendFields: document.querySelectorAll('.results--spend'),
	resultsLeftOverFields: document.querySelectorAll('.results--left-over'),
	resulstLeftOverPerDayFieldPP: document.getElementById('results--left-over-pp--each-day'),
	resulstLeftOverPerDayFieldTB: document.getElementById('results--left-over-tb--each-day'),

	// Calculator state vars
	mode: null, // pp (per person) or total
	q1Answered: false,
	dnClass: 'display-none',
	currentScreen: 's1',
	addCategoryEventAttached: false,
	customFieldCounter: 1,

	// START: Question values updated on keyup

	// Per person
	ppBudget: 0,
	ppPeople: 5,
	ppDays: 7,

	// Total budget
	tbBudget: 0,
	tbDays: 7,

	// Outgoings
	travelCosts: 0,
	accommodationCosts: 0,
	travelInsuranceCosts: 0,
	petCareCosts: 0,
	foodAndDrinkCosts: 0,
	mealsOutCosts: 0,
	activitiesCosts: 0,
	giftsCosts: 0,
	customCosts: {},

	// END: Question values updated on keyup

	init: () => {
		const {
			q1Radios,
			handleQ1,
			ppBudgetField,
			isValidUserInput,
			ppPeopleField,
			ppDaysField,
			tbBudgetField,
			tbDaysField,
			screenOneForm,
			handleScreenOneSubmit,
			handleScreenTwoSubmit,
			travelCostsField,
			accommodationCostsField,
			travelInsuranceCostsField,
			petCareCostsField,
			foodAndDrinkCostsField,
			mealsOutCostsField,
			activitiesCostsField,
			giftsCostsField,
			screenTwoForm,
			backButton,
			handleBackButton,
			addSpendButton,
			showAddSpendField,
			screenThreeFields,
			calculateAndPopulateResults,
			downloadPdfButton,
			handlePdfDownload,
			handleRemoveErrors,
		} = holidayBudgetCalculator;

		// Set up Event Listeners
		q1Radios.forEach(radio => radio.addEventListener('change', () => handleQ1(radio)));

		// Removes the default "0" on enter on the text box
		document.querySelectorAll('input[type="text"]').forEach(input => {
			input.addEventListener('focus', event => {
				const value = event.target.value;
				if (value === '0') event.target.value = '';
			});
		});

		// Stops illegal chars being entered to inputs

		// Allow decimals
		[
			ppBudgetField,
			tbBudgetField,
			travelCostsField,
			accommodationCostsField,
			travelInsuranceCostsField,
			petCareCostsField,
			foodAndDrinkCostsField,
			mealsOutCostsField,
			activitiesCostsField,
			giftsCostsField,
		].forEach(input => input.addEventListener('keydown', event => isValidUserInput(event)));

		// No decimals
		[ppPeopleField, ppDaysField, tbDaysField].forEach(input =>
			input.addEventListener('keydown', event => isValidUserInput(event, false))
		);

		// Per person
		ppBudgetField.addEventListener('keyup', event => (holidayBudgetCalculator.ppBudget = event.target.value));
		ppPeopleField.addEventListener('keyup', event => (holidayBudgetCalculator.ppPeople = event.target.value));
		ppDaysField.addEventListener('keyup', event => (holidayBudgetCalculator.ppDays = event.target.value));

		// Total Budget
		tbBudgetField.addEventListener('keyup', event => (holidayBudgetCalculator.tbBudget = event.target.value));
		tbDaysField.addEventListener('keyup', event => (holidayBudgetCalculator.tbDays = event.target.value));

		travelCostsField.addEventListener('keyup', event => (holidayBudgetCalculator.travelCosts = event.target.value));
		accommodationCostsField.addEventListener(
			'keyup',
			event => (holidayBudgetCalculator.accommodationCosts = event.target.value)
		);
		travelInsuranceCostsField.addEventListener(
			'keyup',
			event => (holidayBudgetCalculator.travelInsuranceCosts = event.target.value)
		);
		petCareCostsField.addEventListener(
			'keyup',
			event => (holidayBudgetCalculator.petCareCosts = event.target.value)
		);
		foodAndDrinkCostsField.addEventListener(
			'keyup',
			event => (holidayBudgetCalculator.foodAndDrinkCosts = event.target.value)
		);
		mealsOutCostsField.addEventListener(
			'keyup',
			event => (holidayBudgetCalculator.mealsOutCosts = event.target.value)
		);
		activitiesCostsField.addEventListener(
			'keyup',
			event => (holidayBudgetCalculator.activitiesCosts = event.target.value)
		);
		giftsCostsField.addEventListener('keyup', event => (holidayBudgetCalculator.giftsCosts = event.target.value));

		// Form submissions
		screenOneForm.addEventListener('submit', event => handleScreenOneSubmit(event));
		screenTwoForm.addEventListener('submit', event => handleScreenTwoSubmit(event));

		// Removing errors
		[ppPeopleField, ppDaysField, tbDaysField].forEach(field =>
			field.addEventListener('keyup', event => handleRemoveErrors(event))
		);

		// Add custom spend
		addSpendButton.addEventListener('click', event => showAddSpendField(event));

		// Screen three update on input
		screenThreeFields.forEach(input => input.addEventListener('keyup', () => calculateAndPopulateResults()));

		// Download button
		downloadPdfButton.addEventListener('click', () => handlePdfDownload());

		// Back button
		backButton.addEventListener('click', () => handleBackButton());
	},

	// Utility functions
	toggleClasses: (selector, classname) => selector.classList.toggle(classname),
	showError: element => element.closest('.field-group').classList.add('field-group--error'),
	hideError: element => element.closest('.field-group').classList.remove('field-group--error'),
	toggleScreens: (s1, s2) => {
		[s1, s2].forEach(screen => screen.classList.toggle('display-none'));
	},
	updateProgressTracker: (t1, t2, stepToGoTo) => {
		const { progressIndicator, progressCounter } = holidayBudgetCalculator;
		[t1, t2].forEach(screen => screen.classList.toggle('display-none'));
		if (stepToGoTo == 'screen-two') {
			progressIndicator.classList = 'holiday-budget-calculator__progress--indicator step-two';
			progressCounter.textContent = '2';
		} else if (stepToGoTo == 'screen-three') {
			progressIndicator.classList = 'holiday-budget-calculator__progress--indicator complete';
			progressCounter.textContent = '3';
		} else {
			progressIndicator.classList = 'holiday-budget-calculator__progress--indicator';
			progressCounter.textContent = '1';
		}
	},
	updateBackButtonText: text => (holidayBudgetCalculator.backButtonText.textContent = text),
	isValidUserInput: (event, allowDecimal = true) => {
		const input = event.target;
		const key = event.key;
		const keyCode = event.keyCode;
		const shiftKey = event.shiftKey;

		// Prevent symbols when Shift key is pressed with number keys
		if (shiftKey && keyCode >= 48 && keyCode <= 57) {
			event.preventDefault();
			return false;
		}

		// Allow numbers (0-9) and numeric keypad keys (96-105) without Shift key
		if (!shiftKey && ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105))) {
			const value = input.value;
			const cursorPos = input.selectionStart;

			// Check if there's a decimal point and the cursor is after it
			const decimalIndex = value.indexOf('.');
			if (decimalIndex !== -1 && cursorPos > decimalIndex) {
				// Allow only two digits after the decimal point
				const decimalPart = value.substring(decimalIndex + 1);
				if (decimalPart.length >= 2) {
					event.preventDefault();
					return false;
				}
			}
			return true;
		}

		// Allow backspace (8), delete (46), arrow keys (37-40), tab (9), and enter (13)
		if (keyCode === 8 || keyCode === 46 || (keyCode >= 37 && keyCode <= 40) || keyCode === 9 || keyCode === 13) {
			return true;
		}

		// Allow a single decimal point if allowDecimal is true
		if (allowDecimal && key === '.' && input.value.indexOf('.') === -1) {
			return true;
		}

		// Prevent any other keys (including symbols)
		event.preventDefault();
		return false;
	},
	formatPrice: price => {
		const asNumber = Number(price);
		if (Number.isInteger(price)) {
			return asNumber < 0 ? `-£${Math.abs(asNumber)}` : `£${asNumber}`;
		} else {
			return asNumber < 0 ? `-£${Math.abs(asNumber).toFixed(2)}` : `£${asNumber.toFixed(2)}`;
		}
	},
	createPdfCost: (labelText, cost) => {
		const { formatPrice } = holidayBudgetCalculator;
		const newCostElement = document.createElement('p');
		newCostElement.style.breakInside = 'avoid';
		newCostElement.style.letterSpacing = 'normal';
		newCostElement.style.display = 'flex';
		newCostElement.style.justifyContent = 'space-between';
		newCostElement.style.marginBottom = '4px';
		newCostElement.style.fontSize = '18px';
		newCostElement.style.lineHeight = '26px';
		const htmlToInject = `
            <span class="pdf--cost-name">${labelText}</span>
            <span class="pdf--cost-price" style="font-weight: 600; padding-left: 16px;">${formatPrice(cost)}</span>
        `;
		newCostElement.innerHTML = htmlToInject;
		return newCostElement;
	},
	isZeroOrEmpty: value => Number(value) === 0 || value === '',

	// Handling initial question answered
	handleQ1: radio => {
		const {
			page1PPFlow,
			page1TotalFlow,
			toggleClasses,
			dnClass,
			q1ErrorMsg,
			hideError,
			screenTwoPPTitle,
			screenTwoTBTitle,
		} = holidayBudgetCalculator;
		const { screenTwoTitle } = holidayBudgetCalculator;
		hideError(q1ErrorMsg);
		holidayBudgetCalculator.mode = radio.value;
		screenTwoTitle.textContent = holidayBudgetCalculator.mode == 'pp' ? screenTwoPPTitle : screenTwoTBTitle;
		if (holidayBudgetCalculator.q1Answered) {
			[page1PPFlow, page1TotalFlow].forEach(selector => toggleClasses(selector, dnClass));
		} else {
			const chosenFlow = holidayBudgetCalculator.mode == 'pp' ? page1PPFlow : page1TotalFlow;
			toggleClasses(chosenFlow, dnClass);
			holidayBudgetCalculator.q1Answered = true;
		}
	},

	handleRemoveErrors: event => {
		console.log(event.target.value);
		const element = event.target;
		if (holidayBudgetCalculator.isZeroOrEmpty(element.value)) return;
		holidayBudgetCalculator.hideError(element);
	},

	// Handling form submissions
	handleScreenOneSubmit: event => {
		const {
			q1Radios,
			q1ErrorMsg,
			showError,
			toggleScreens,
			updateProgressTracker,
			screenOne,
			screenTwo,
			progressTitleOne,
			progressTitleTwo,
			backButton,
			toggleClasses,
			isZeroOrEmpty,
			ppDays,
			ppPeople,
			tbDays,
			ppDaysErrorMsg,
			ppPeopleErrorMsg,
			tbDaysErrorMsg,
		} = holidayBudgetCalculator;
		event.preventDefault();

		// Check for errors
		const radiosValid = Array.from(q1Radios).some(radio => radio.checked);
		if (!radiosValid) {
			showError(q1ErrorMsg);
			return;
		}

		if (holidayBudgetCalculator.mode == 'pp') {
			if (isZeroOrEmpty(ppPeople)) {
				showError(ppPeopleErrorMsg);
				return;
			}

			if (isZeroOrEmpty(ppDays)) {
				showError(ppDaysErrorMsg);
				return;
			}
		} else {
			if (isZeroOrEmpty(tbDays)) {
				showError(tbDaysErrorMsg);
				return;
			}
		}

		toggleScreens(screenOne, screenTwo);
		updateProgressTracker(progressTitleOne, progressTitleTwo, 'screen-two');
		toggleClasses(backButton, 'display-none');
		holidayBudgetCalculator.currentScreen = 's2';

		holidayBudgetCalculator.progressIndicator.closest('.row').scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest',
		});
	},

	handleScreenTwoSubmit: event => {
		const {
			screenTwo,
			screenThree,
			toggleScreens,
			updateProgressTracker,
			progressTitleTwo,
			progressTitleThree,
			updateBackButtonText,
			calculateAndPopulateResults,
			screenThreePPTitle,
			screenThreeTBTitle,
			mode,
			s3BackButtonText,
		} = holidayBudgetCalculator;
		const { screenThreeTitle } = holidayBudgetCalculator;
		event.preventDefault();
		screenThreeTitle.textContent = mode == 'pp' ? screenThreePPTitle : screenThreeTBTitle;
		toggleScreens(screenTwo, screenThree);
		updateProgressTracker(progressTitleTwo, progressTitleThree, 'screen-three');
		updateBackButtonText(s3BackButtonText);
		holidayBudgetCalculator.currentScreen = 's3';

		// Calculate results
		calculateAndPopulateResults();

		holidayBudgetCalculator.progressIndicator.closest('.row').scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest',
		});
	},

	handleBackButton: () => {
		const {
			updateBackButtonText,
			s2BackButtonText,
			toggleScreens,
			screenOne,
			screenTwo,
			screenThree,
			updateProgressTracker,
			progressTitleOne,
			progressTitleTwo,
			progressTitleThree,
			backButton,
			toggleClasses,
		} = holidayBudgetCalculator;
		if (holidayBudgetCalculator.currentScreen == 's2') {
			toggleClasses(backButton, 'display-none');
			toggleScreens(screenTwo, screenOne);
			updateProgressTracker(progressTitleTwo, progressTitleOne, 'screen-one');
			holidayBudgetCalculator.currentScreen = 's1';
		} else {
			updateBackButtonText(s2BackButtonText);
			toggleScreens(screenTwo, screenThree);
			updateProgressTracker(progressTitleTwo, progressTitleThree, 'screen-two');
			holidayBudgetCalculator.currentScreen = 's2';
		}

		holidayBudgetCalculator.progressIndicator.closest('.row').scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest',
		});
	},

	showAddSpendField: event => {
		event.preventDefault();
		const { addSpendMarkup, toggleClasses, addSpendButton, handleAddCategory } = holidayBudgetCalculator;
		[addSpendMarkup, addSpendButton].forEach(element => toggleClasses(element, 'display-none'));
		if (!holidayBudgetCalculator.addCategoryEventAttached)
			document.getElementById('add-category-button').addEventListener('click', event => handleAddCategory(event));
	},

	handleAddCategory: event => {
		event.preventDefault();
		const addCategoryField = document.getElementById('add-category-field');
		const labelText = addCategoryField.value;
		if (labelText === '') return;
		const { addSpendMarkup, addSpendButton, toggleClasses, handleAddCustomCost, isValidUserInput } =
			holidayBudgetCalculator;
		const newField = document.createElement('fieldset');
		newField.className = 'field-group field-group--small field-group--underline';
		newField.innerHTML = `
            <div class="question-shell">
                <label class="label--standard" for="outgoings-${labelText}-${holidayBudgetCalculator.customFieldCounter}">${labelText}</label>
            </div>
            <div class="input-shell-container">
                <div class="input-shell input-shell--standard input-shell--prefixed input-shell--prefixed--pound">
                    <input value="0" type="text" id="outgoings-${labelText}-${holidayBudgetCalculator.customFieldCounter}" data-outgoing-name="${labelText}-${holidayBudgetCalculator.customFieldCounter}" name="outgoings-${labelText}-${holidayBudgetCalculator.customFieldCounter}" maxlength="6" inputmode="decimal" aria-describedby="" class="half-width">
                </div>
            </div>
        `;
		addSpendMarkup.parentNode.insertBefore(newField, addSpendMarkup);
		addCategoryField.value = '';
		[addSpendMarkup, addSpendButton].forEach(element => toggleClasses(element, 'display-none'));
		const newCostField = document.getElementById(
			`outgoings-${labelText}-${holidayBudgetCalculator.customFieldCounter}`
		);

		// Add neccessary event listeners to new field
		newCostField.addEventListener('focus', event => {
			const value = event.target.value;
			if (value === '0') event.target.value = '';
		});
		newCostField.addEventListener('keydown', event => isValidUserInput(event));
		newCostField.addEventListener('keyup', event => handleAddCustomCost(event));

		holidayBudgetCalculator.addCategoryEventAttached = true;
		holidayBudgetCalculator.customFieldCounter++;
	},

	handleAddCustomCost: event => {
		const { calculateAndPopulateResults } = holidayBudgetCalculator;
		const input = event.target;
		const id = input.getAttribute('data-outgoing-name');
		let value = input.value.trim();
		if (value === '' || value === '0') {
			holidayBudgetCalculator.customCosts[id] = 0;
		} else {
			value = parseFloat(value);
			holidayBudgetCalculator.customCosts[id] = value;
		}

		calculateAndPopulateResults();
	},

	calculateAndPopulateResults: () => {
		const {
			travelCosts,
			accommodationCosts,
			travelInsuranceCosts,
			petCareCosts,
			foodAndDrinkCosts,
			mealsOutCosts,
			activitiesCosts,
			giftsCosts,
			customCosts,
			ppPeople,
			ppDays,
			tbDays,
			resultsDaysFields,
			resultsTotalSpendFields,
			resultsLeftOverFields,
			resulstLeftOverPerDayFieldPP,
			resulstLeftOverPerDayFieldTB,
			ppCostEachDay,
			tbCostEachDay,
			resultsBudgetField,
			formatPrice,
			resultsTotalSpendFieldPPOnly,
			resultsLeftOverEachDay,
		} = holidayBudgetCalculator;
		let { tbBudget, ppBudget } = holidayBudgetCalculator;
		let ppTotalSpend, totalSpend, ppAmountLeft, ppBudgetPerDay, amountLeft, amountLeftEachDay;

		let sumOfCustomCosts = 0;
		for (const key in customCosts) {
			if (customCosts.hasOwnProperty(key)) {
				sumOfCustomCosts += customCosts[key];
			}
		}

		totalSpend = [
			travelCosts,
			accommodationCosts,
			travelInsuranceCosts,
			petCareCosts,
			foodAndDrinkCosts,
			mealsOutCosts,
			activitiesCosts,
			giftsCosts,
			sumOfCustomCosts,
		].reduce((total, cost) => total + parseFloat(cost) || 0, 0);

		// Ternary to set val to 0 if input is empty
		tbBudget = tbBudget >= 0 ? parseFloat(tbBudget) : 0;
		ppBudget = ppBudget >= 0 ? parseFloat(ppBudget) : 0;

		if (holidayBudgetCalculator.mode == 'pp') {
			ppTotalSpend = totalSpend;
			totalSpend = totalSpend * ppPeople;
			ppAmountLeft = ppBudget - ppTotalSpend;
			ppBudgetPerDay = ppAmountLeft / ppDays;

			// Populate
			resultsDaysFields.forEach(field => (field.textContent = ppDays));
			resultsBudgetField.textContent = `${formatPrice(ppBudget)} per person`;
			resultsTotalSpendFieldPPOnly.parentElement.classList.remove('display-none');
			resultsTotalSpendFieldPPOnly.textContent = `${formatPrice(totalSpend)}`;
			resultsTotalSpendFields.forEach(field => (field.textContent = `${formatPrice(ppTotalSpend)} per person`));
			resultsLeftOverFields.forEach(field => (field.textContent = `${formatPrice(ppAmountLeft)} per person`));
			resulstLeftOverPerDayFieldPP.textContent = `${formatPrice(ppBudgetPerDay)}`;
			resultsLeftOverEachDay.textContent = ppCostEachDay.textContent;
		} else {
			amountLeft = tbBudget - totalSpend;
			amountLeftEachDay = amountLeft / tbDays;

			// Populate
			resultsTotalSpendFieldPPOnly.parentElement.classList.add('display-none');
			resultsDaysFields.forEach(field => (field.textContent = tbDays));
			resultsTotalSpendFields.forEach(field => (field.textContent = `${formatPrice(totalSpend)}`));
			resultsBudgetField.textContent = `${formatPrice(tbBudget)}`;
			resultsLeftOverFields.forEach(field => (field.textContent = `${formatPrice(amountLeft)}`));
			resulstLeftOverPerDayFieldTB.textContent = `${formatPrice(amountLeftEachDay)}`;
			resultsLeftOverEachDay.textContent = tbCostEachDay.textContent;
		}
	},

	handlePdfDownload: () => {
		const {
			mode,
			ppDays,
			tbDays,
			ppPeople,
			travelCostsField,
			accommodationCostsField,
			travelInsuranceCostsField,
			petCareCostsField,
			foodAndDrinkCostsField,
			mealsOutCostsField,
			activitiesCostsField,
			giftsCostsField,
			travelCosts,
			accommodationCosts,
			travelInsuranceCosts,
			petCareCosts,
			foodAndDrinkCosts,
			mealsOutCosts,
			activitiesCosts,
			giftsCosts,
			customCosts,
			formatPrice,
			createPdfCost,
		} = holidayBudgetCalculator;
		let { tbBudget, ppBudget } = holidayBudgetCalculator;
		const isPP = mode == 'pp';
		const pdfDaysFields = document.querySelectorAll('.pdf--days');
		const pdfBudgetPerPersonWrapper = document.getElementById('pdf--budget-wrapper');
		const pdfBudgetPerPerson = isPP ? document.getElementById('pdf--budget') : null;
		const pdfPpText = isPP ? document.querySelectorAll('.pdf--pp-text') : null;
		const totalBudget = document.getElementById('pdf--total-budget');
		const pdfCostsList = document.getElementById('pdf--outgoings-list');

		tbBudget = parseFloat(tbBudget);
		ppBudget = parseFloat(ppBudget);

		pdfDaysFields.forEach(field => (isPP ? (field.textContent = ppDays) : (field.textContent = tbDays)));
		if (mode == 'pp') {
			pdfBudgetPerPerson.textContent = `${formatPrice(ppBudget)}`;
			pdfBudgetPerPersonWrapper.style.display = 'flex';
			pdfPpText.forEach(ppText => (ppText.style.display = 'inline'));
		} else {
			pdfBudgetPerPersonWrapper.style.display = 'none';
		}

		totalBudget.textContent = isPP ? `${formatPrice(ppBudget * ppPeople)}` : `${formatPrice(tbBudget)}`;

		// First remove any current entries
		const paragraphs = pdfCostsList.querySelectorAll('p');
		for (let i = 1; i < paragraphs.length; i++) {
			pdfCostsList.removeChild(paragraphs[i]);
		}

		// Populate costs list
		[
			{ field: travelCostsField, cost: travelCosts },
			{ field: accommodationCostsField, cost: accommodationCosts },
			{ field: travelInsuranceCostsField, cost: travelInsuranceCosts },
			{ field: petCareCostsField, cost: petCareCosts },
			{ field: foodAndDrinkCostsField, cost: foodAndDrinkCosts },
			{ field: mealsOutCostsField, cost: mealsOutCosts },
			{ field: activitiesCostsField, cost: activitiesCosts },
			{ field: giftsCostsField, cost: giftsCosts },
		].forEach(item => {
			const tCost = parseFloat(item.cost);
			if (tCost == 0 || Number.isNaN(tCost)) return;
			const labelText = item.field.closest('fieldset').querySelector('.label--standard').textContent;
			if (!labelText || labelText == '') return;

			// Create the cost text
			pdfCostsList.appendChild(createPdfCost(labelText, tCost));
		});

		// Other costs
		let sumOfCustomCosts = 0;
		for (const key in customCosts) {
			if (customCosts.hasOwnProperty(key)) {
				sumOfCustomCosts += customCosts[key];
			}
		}
		if (sumOfCustomCosts > 0) pdfCostsList.appendChild(createPdfCost('Other costs', sumOfCustomCosts));

		// Total costs
		const total = [
			travelCosts,
			accommodationCosts,
			travelInsuranceCosts,
			petCareCosts,
			foodAndDrinkCosts,
			mealsOutCosts,
			activitiesCosts,
			giftsCosts,
			sumOfCustomCosts,
		].reduce((total, cost) => total + parseFloat(cost) || 0, 0);
		pdfCostsList.appendChild(createPdfCost('Total', total));

		document.getElementById('pdf--budgetForDays').textContent = isPP
			? `${formatPrice(ppBudget)} per person`
			: `${formatPrice(tbBudget)}`;
		document.getElementById('pdf--totalSpendForDays').textContent = isPP
			? `${formatPrice(total * ppPeople)}`
			: `${formatPrice(total)}`;

		const amountLeft = isPP ? `${formatPrice(ppBudget - total)} per person` : `${formatPrice(tbBudget - total)}`;
		document.getElementById('pdf--amount-left').textContent = amountLeft;

		const amountLeftPerDay = isPP
			? `${formatPrice((ppBudget - total) / ppDays)} per person`
			: `${formatPrice((tbBudget - total) / tbDays)}`;
		document.getElementById('pdf--each-day').textContent = amountLeftPerDay;

		holidayBudgetCalculator.generatePDF();
	},

	async generatePDF() {
		const pdfOptions = {
			margin: 16,
			filename: 'Confused.com_Holiday_Budget.pdf',
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: { scale: 2 },
			jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
		};

		const element = document.getElementById('printPageWrapper');
		html2pdf(element, pdfOptions);
	},
};

document.addEventListener('DOMContentLoaded', function () {
	const hbCalc = document.getElementById('cnfsd-hbc');
	if (hbCalc) holidayBudgetCalculator.init();
});
